// extracted by mini-css-extract-plugin
export var content = "TextWithBackgroundImageModule-module--content--a17ca";
export var contentContainer = "TextWithBackgroundImageModule-module--contentContainer--dd419";
export var greenBackground = "TextWithBackgroundImageModule-module--greenBackground--67e7e";
export var image = "TextWithBackgroundImageModule-module--image--4d577";
export var imageContainer = "TextWithBackgroundImageModule-module--imageContainer--ff1c8";
export var purpleBackground = "TextWithBackgroundImageModule-module--purpleBackground--df3ba";
export var text = "TextWithBackgroundImageModule-module--text--7ff37";
export var textContainer = "TextWithBackgroundImageModule-module--textContainer--20507";
export var title = "TextWithBackgroundImageModule-module--title--444a7";